import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { AddItemsToLoad, logisticsActionCreators, LogisticsActionKeys } from '..';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { unallocatedProductsActionCreators } from '../../unallocatedProducts';
import { addItemsToLoad } from '../logisticsApi';

function* addItemsToLoadSaga(action: AddItemsToLoad) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(addItemsToLoad, action.payload.loadNumber, action.payload.unallocatedProducts);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(logisticsActionCreators.setLoad(response.value.value));
      yield put(unallocatedProductsActionCreators.remove(action.payload.unallocatedProducts.map(x => x.inventTransId)));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchAddItemsToLoad() {
  yield takeEvery(LogisticsActionKeys.ADD_ITEMS_TO_LOAD, addItemsToLoadSaga);
}
